const PlayerState = {
  UNKNOWN: "UNKNOWN",
  UNLOADING: "UNLOADING",
  UNLOADED: "UNLOADED",
  LOADING: "LOADING",
  LOADED: "LOADED",
  PLAY_REQUESTED: "PLAY_REQUESTED",
  PLAYING: "PLAYING",
  PAUSED: "PAUSED"
};
const PlayerViewMode = {
  INLINE: "INLINE",
  FULL_SCREEN: "FULL_SCREEN",
  PICTURE_IN_PICTURE: "PICTURE_IN_PICTURE"
};

export { PlayerState, PlayerViewMode };
//# sourceMappingURL=constants.js.map
